import { render } from "./ImportSportFixtures.vue?vue&type=template&id=3549e14a"
import script from "./ImportSportFixtures.vue?vue&type=script&lang=js"
export * from "./ImportSportFixtures.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__